import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import {
  TableWrapper,
  TopControls,
  SelectContainer,
  PaginationContainer,
  PageButton,
  TableContainer,
  StyledTable,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHeaderCell,
  ControlsContainer,
  LeftControls,
  RightControls,
  SearchInputContainer,
} from './components/TableStyles';
import { useTable } from './hooks/useTable';

const Table = ({
  children,
  responsive = true,
  paginate = false,
  searchable = false,
  onFilterClick,
  onSettingsClick,
  searchPlaceholder = 'Buscar',
  ...props
}) => {
  const {
    headerNode,
    paginatedBodyNode,
    otherNodes,
    currentPage,
    totalPages,
    itemsPerPage,
    searchTerm,
    pageNumbers,
    handlePageChange,
    handleSearchChange,
    handleItemsPerPageChange,
  } = useTable({ children, paginate, searchable });

  const tableContent = (
    <React.Fragment>
      {searchable && (
        <ControlsContainer>
          <LeftControls />
          <RightControls>
            <Button
              variant="light"
              onClick={onFilterClick}
              style={{ gap: '0.5rem', color: '#344054', borderColor: '#EAECF0', padding: '0.5rem 0.75rem', fontWeight: 500 }}
            >
              <i className="fa fa-filter" style={{ color: '#667085' }} /> Filtrar
            </Button>
            {onSettingsClick && (
              <Button
                variant="light"
                onClick={onSettingsClick}
                style={{ color: '#667085', borderColor: '#EAECF0', padding: '0.5rem 0.75rem' }}
              >
                <i className="fa fa-sliders" />
              </Button>
            )}
            <SearchInputContainer>
              <i className="fa fa-search" />
              <input
                type="text"
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </SearchInputContainer>
          </RightControls>
        </ControlsContainer>
      )}
      <StyledTable {...props}>
        {headerNode}
        {paginatedBodyNode}
        {otherNodes}
      </StyledTable>
    </React.Fragment>
  );

  const mainContent = responsive ? (
    <TableContainer>{tableContent}</TableContainer>
  ) : (
    tableContent
  );

  if (!paginate) {
    return <TableWrapper>{mainContent}</TableWrapper>;
  }

  return (
    <TableWrapper>
      <TopControls>
        <SelectContainer>
          <span>Mostrar:</span>
          <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span>resultados</span>
        </SelectContainer>
      </TopControls>

      {mainContent}

      <PaginationContainer>
        <PageButton
          disabled={currentPage <= 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Anterior
        </PageButton>

        {pageNumbers.map((page) => (
          <PageButton
            key={page}
            active={currentPage === page}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </PageButton>
        ))}

        <PageButton
          disabled={currentPage >= totalPages || totalPages === 0}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Próxima
        </PageButton>
      </PaginationContainer>
    </TableWrapper>
  );
};

Table.Header = TableHeader;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.HeaderCell = TableHeaderCell;

Table.propTypes = {
  children: PropTypes.node.isRequired,
  responsive: PropTypes.bool,
  hover: PropTypes.bool,
  striped: PropTypes.bool,
  paginate: PropTypes.bool,
  searchable: PropTypes.bool,
  onFilterClick: PropTypes.func,
  onSettingsClick: PropTypes.func,
  searchPlaceholder: PropTypes.string,
};

export default Table;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Table/Table.jsx